module.exports = __webpack_public_path__ + "static/media/OurProduct-TealWave.d5895183.svg";